import { render, staticRenderFns } from "./EditingDFCheckbox.vue?vue&type=template&id=6086d164&"
import script from "./EditingDFCheckbox.vue?vue&type=script&lang=js&"
export * from "./EditingDFCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports